import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import Link from 'next/link';
import Image from 'next/image';
import Axios from 'axios';
import moment from 'moment';
import { Menu, Dropdown, Typography } from 'antd';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Slider from 'react-slick';
import ReactPlayer from 'react-player/lazy';
import { toast } from 'react-toastify';
import { LightgalleryItem } from 'react-lightgallery';
import { httpsCallable } from 'firebase/functions';
import { doc, getDoc } from 'firebase/firestore/lite';
import TabsComponent from './BottomTabs';
import CheckoutDialog from '../Dialog/DialogCheckout';
import PlacebidDialog from '../Dialog/DialogPlacebid';
import NftDetailsEmbadedAssetsDialog from './NftDetailsEmbadedAssetsDialog';
import { musicartLikeNFT } from '../../services/likeNft';
import { getUserName, countDecimals } from '../../services/common-query';
import { calculateNfts } from '../../helpers/regex';
import { firebaseFireStore } from '../../config/firebaseFirestore';
// import { useMediaQuery } from '@material-ui/core';
import { envMode } from '../../config/fire-conf';
import { firebaseFunctions } from '../../config/firebaseFunctions';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import Fab from '@material-ui/core/Fab';
import musicAnimation from '../Card/music-lottie.json';

const Lottie = dynamic(() => import('react-lottie'), { ssr: false });
import OtherNftsContainer from './OtherNftsContainer';
import NftSchema from '../../schema/NftSchema';
import { NextSeo, SocialProfileJsonLd, ProductJsonLd } from 'next-seo';
import Countdown from 'react-countdown';

const { Text } = Typography;

const useStyles = makeStyles((theme) => ({
  // card: {
  //   maxWidth: 345,
  //   margin: theme.spacing(2),
  // },
  // media: {
  //   height: "100%",
  //   minHeight: 400,
  //   width: "100%",
  //   borderRadius: 25,
  // },
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
}));

let selectedIndex = 0;
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  dotsClass: 'slick-dots slick-thumb',

  appendDots: (dots) => (
    <div
      style={{
        marginBottom: 45,
        width: 80,
        display: 'flex',
        justifyContent: 'center',
        height: 20,
        zIndex: 1,
        position: 'absolute',
        marginLeft: 'auto',
        marginRight: 'auto',
        left: 0,
        right: 0,
        textAlign: 'center',
      }}
    >
      <div
        onClick={(e) => {
          e.preventDefault();
        }}
        style={{ cursor: 'default' }}
      >
        <ul className="discover-dots-ul"> {dots} </ul>
      </div>
    </div>
  ),
  customPaging: (i) => <div className="dots-discover"></div>,
};
let nftUrl;

export default function NftDetailContainer(props) {
  // const isMobile = useMediaQuery('(max-width:600px)');
  const { isMultiple, data } = props;
  const classes = useStyles();
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const bsvRate = useSelector((state) => state.bsvRateReducer.bsvRate);
  const ethRate = useSelector((state) => state.bsvRateReducer.ethRate);

  const router = useRouter();
  const { nftId, multiNftId } = router.query;
  const [nftData, setnftData] = useState(null);
  const [liked, setliked] = useState(false);
  const [audioPlay, setaudioPlay] = useState(false);

  const [likesCollectionExits, setlikesCollectionExits] = useState(false);
  const [confirmationCheckoutDialogState, setconfirmationCheckoutDialogState] =
    useState(false);
  const [confirmationPlacebidDialogState, setconfirmationPlacebidDialogState] =
    useState(false);

  // const [imageViewerDialogState, setimageViewerDialogState] = useState(false);
  const [artistDetails, setartistDetails] = useState(null);

  const [embedAssetsDialogState, setEmbedAssetsDialogState] = useState(false);
  // const [spotifyDialogState, setSpotifyDialogState] = useState(false);
  // const [photoIndex, setphotoIndex] = useState(0);
  // const [photoArr, setphotoArr] = useState(null);
  const [likeDisabled, setlikeDisabled] = useState(true);
  const [showData, setshowData] = useState(true);
  const [checkSellerView, setcheckSellerView] = useState(false);
  const [checkoutUserName, setcheckoutUserName] = useState('');
  const [NFT_Code, setNFT_Code] = useState('');
  const [nftCount, setnftCount] = useState(null);
  const [usdPrice, setUsdPrice] = useState(0);
  const [showftNftDetails, setshowftNftDetails] = useState(true);
  const [auctionTimerEnded, setauctionTimerEnded] = useState(false);

  const toastId = React.useRef(null);

  useEffect(() => {
    if (props.isMultiple) {
      nftUrl = `${window.location.origin}/nft/${nftId}/${multiNftId}`;
    } else {
      nftUrl = `${window.location.origin}/nft/${nftId}`;
    }
  }, [nftId, multiNftId, props.isMultiple]);

  useEffect(() => {
    if (props?.data) {
      getNftSummmary();
    }
  }, [props.data]);

  useEffect(() => {
    if (props?.musicData) {
      setartistDetails({ ...props.musicData });
    }
  }, [props.musicData]);

  // useEffect(() => {
  //   if (
  //     nftId &&
  //     checkSellerView &&
  //     userDataRedux &&
  //     userDataRedux.uid &&
  //     nftData
  //   ) {
  //     setcheckSellerView(false);
  //     checkSellerViewFunc();
  //   } else if (checkSellerView && !userDataRedux) {
  //     router.push('/discover');
  //   }
  // }, [nftId, userDataRedux, checkSellerView, nftData]);

  useEffect(() => {
    if (nftId && userDataRedux && userDataRedux.uid) {
      getLikeState();
      increaseNftViewCount();
    }
  }, [nftId, userDataRedux]);

  useEffect(async () => {
    const siteDomain =
      window.location &&
      window.location.origin &&
      window.location.origin.includes('localhost')
        ? process.env.customKey
        : window.location.origin;

    await Axios.get(
      `https://iframe.ly/api/oembed?url=${siteDomain}/nft/${nftId}&api_key=a9686bdb001bb71fe95a63`,
    )
      .then((res) => {
        setNFT_Code(res?.data?.html);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [nftId]);

  const increaseNftViewCount = async () => {
    try {
      let viewApi = httpsCallable(firebaseFunctions, 'musicartNftViewsCount');

      let apiRes = await viewApi({
        tokenId: nftId,
      });
    } catch (err) {}
  };

  const getNameFromId = async (id) => {
    let lname = await getUserName(id);

    if (lname) {
      setcheckoutUserName(lname);
    } else {
      setcheckoutUserName('unknown');
    }
  };

  const getNftSummmary = async () => {
    let gettingData = { ...props.data };

    // let pass = false;
    // if (
    //   gettingData &&
    //   gettingData.activeInMarketPlace &&
    //   gettingData.adminState === 'ACCEPT'
    // ) {
    //   if (props.isMultiple) {
    //     if (
    //       props.isMultiple &&
    //       gettingData.multipleNftDetails &&
    //       multiNftId &&
    //       gettingData.multipleNftDetails[multiNftId] &&
    //       gettingData.multipleNftDetails[multiNftId].activeInMarketPlace &&
    //       gettingData.multipleNftDetails[multiNftId].adminState === 'ACCEPT'
    //     ) {
    //       pass = true;
    //     }
    //   } else {
    //     pass = true;
    //   }
    // }

    // if (!pass) {
    //   setshowData(false);
    //   // setcheckSellerView(true);
    // } else {
    //   setshowftNftDetails(true);
    // }

    let obj;
    if (props.isMultiple) {
      obj = { ...gettingData };
      obj = { ...obj, ...obj.multipleNftDetails[multiNftId] };
    } else {
      obj = gettingData;
      if (obj.isMultiple) {
        let startingPrice = 0;

        Object.values(obj.multipleNftDetails).map((ele, index) => {
          if (ele.adminState === 'ACCEPT' && ele.activeInMarketPlace) {
            if (
              ele.nftSaleType &&
              ele.nftSaleType !== 'Auctioning' &&
              ele.price &&
              (!startingPrice ||
                (startingPrice && Number(ele.price) < startingPrice))
            ) {
              startingPrice = Number(ele.price);
            } else if (
              ele.nftSaleType &&
              ele.nftSaleType === 'Auctioning' &&
              ele.auctionEndTime &&
              ele.minBiddingPrice &&
              (!startingPrice ||
                (startingPrice && Number(ele.minBiddingPrice) < startingPrice))
            ) {
              startingPrice = Number(ele.minBiddingPrice);
              obj.nftSaleType = 'Auctioning';
            }
          }
        });

        obj = { ...obj, startingPrice: startingPrice, multiView: true };
      }
    }
    if (props.isMultiple || (!props.isMultiple && !obj.isMultiple)) {
      getNameFromId(obj.userId);
    }
    if (obj.appleMusic) {
      obj.apple = obj.appleMusic;
    }

    //setting nft count
    let nftCount =
      isMultiple && multiNftId
        ? obj.multipleNftDetails[multiNftId] &&
          `No ${obj.multipleNftDetails[multiNftId].index}`
        : calculateNfts(obj.multipleNftDetails);
    setnftCount(nftCount);

    if (obj.audioCoverFile250 && !Array.isArray(obj.audioCoverFile250)) {
      obj.audioCoverFile250 = [obj.audioCoverFile250];
    }
    if (obj.audioCoverFile1500 && !Array.isArray(obj.audioCoverFile1500)) {
      obj.audioCoverFile1500 = [obj.audioCoverFile1500];
    }
    if (obj.audioCoverFile10000 && !Array.isArray(obj.audioCoverFile10000)) {
      obj.audioCoverFile10000 = [obj.audioCoverFile10000];
    }

    setnftData(obj);
  };

  // const checkSellerViewFunc = async () => {
  //   let pass = false;

  //   if (
  //     userDataRedux &&
  //     userDataRedux.uid &&
  //     nftData &&
  //     !nftData.isMultiple &&
  //     nftData.userId === userDataRedux.uid
  //   ) {
  //     pass = true;
  //   } else if (
  //     userDataRedux &&
  //     userDataRedux.uid &&
  //     nftData &&
  //     nftData.isMultiple &&
  //     nftData.usersId &&
  //     nftData.usersId.includes(userDataRedux.uid) &&
  //     !multiNftId
  //   ) {
  //     pass = true;
  //   } else if (
  //     userDataRedux &&
  //     userDataRedux.uid &&
  //     nftData &&
  //     nftData.isMultiple &&
  //     multiNftId &&
  //     nftData.multipleNftDetails &&
  //     nftData.multipleNftDetails[multiNftId] &&
  //     nftData.multipleNftDetails[multiNftId].userId &&
  //     nftData.multipleNftDetails[multiNftId].userId === userDataRedux.uid
  //   ) {
  //     pass = true;
  //   } else {
  //     await getDoc(doc(firebaseFireStore, 'admin', 'adminList')).then((doc) => {
  //       if (
  //         doc.exists &&
  //         doc.data() &&
  //         doc.data().admins.includes(userDataRedux.uid)
  //       ) {
  //         //user is admin
  //         pass = true;
  //       }
  //     });
  //   }

  //   if (pass) {
  //     setshowData(true);
  //     setshowftNftDetails(true);
  //   } else {
  //     router.push('/discover');
  //   }
  // };

  const getLikeState = async () => {
    let dataRef = await getDoc(
      doc(
        firebaseFireStore,
        'musicartUserData',
        userDataRedux.uid,
        'userDetails',
        'likedNfts',
      ),
    );

    if (dataRef.exists) {
      setlikesCollectionExits(true);
      const gettingData = dataRef.data();
      if (
        gettingData?.likedNfts &&
        ((gettingData?.likedNfts?.includes(nftId) && !props.isMultiple) ||
          (props.isMultiple &&
            gettingData?.likedNfts?.includes(
              multiNftId + '-MultipleNft-' + nftId,
            )))
      ) {
        setliked(true);
      }
    } else {
      setliked(false);
      setlikesCollectionExits(false);
    }

    setlikeDisabled(false);
  };

  const redirectTo = (link) => {
    return window?.open(link);
  };

  const menuDropdown = (
    <Menu style={{ width: '200px', paddingBottom: '0' }}>
      <Menu.Item
        className="py-3 share_wrapper"
        onClick={() =>
          redirectTo(`https://www.facebook.com/sharer/sharer.php?u=${nftUrl}`)
        }
      >
        <div className="flex items-center text-sm text-blueGray-700">
          <div className="share__link share__link--fb flex justify-around">
            <svg
              width="12"
              height="16"
              viewBox="0 0 9 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5.56341 16.8197V8.65888H7.81615L8.11468 5.84663H5.56341L5.56724 4.43907C5.56724 3.70559 5.63693 3.31257 6.69042 3.31257H8.09873V0.5H5.84568C3.1394 0.5 2.18686 1.86425 2.18686 4.15848V5.84695H0.499939V8.6592H2.18686V16.8197H5.56341Z" />
            </svg>
          </div>
          <span className="font-semibold px-3 block">Share on Facebook</span>
        </div>
      </Menu.Item>
      <Menu.Item
        onClick={() => redirectTo(`https://twitter.com/share?url=${nftUrl}`)}
        className="py-3 share_wrapper border-t"
      >
        <div className="flex items-center text-sm text-blueGray-700">
          <div className="share__link share__link--tw">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M7.55075 3.19219L7.58223 3.71122L7.05762 3.64767C5.14804 3.40404 3.47978 2.57782 2.06334 1.1902L1.37085 0.501686L1.19248 1.01013C0.814766 2.14353 1.05609 3.34048 1.843 4.14552C2.26269 4.5904 2.16826 4.65396 1.4443 4.38914C1.19248 4.3044 0.972149 4.24085 0.951164 4.27263C0.877719 4.34677 1.12953 5.31069 1.32888 5.69202C1.60168 6.22165 2.15777 6.74068 2.76631 7.04787L3.28043 7.2915L2.67188 7.30209C2.08432 7.30209 2.06334 7.31268 2.12629 7.53512C2.33613 8.22364 3.16502 8.95452 4.08833 9.2723L4.73884 9.49474L4.17227 9.8337C3.33289 10.321 2.34663 10.5964 1.36036 10.6175C0.888211 10.6281 0.5 10.6705 0.5 10.7023C0.5 10.8082 1.78005 11.4014 2.52499 11.6344C4.75983 12.3229 7.41435 12.0264 9.40787 10.8506C10.8243 10.0138 12.2408 8.35075 12.9018 6.74068C13.2585 5.88269 13.6152 4.315 13.6152 3.56293C13.6152 3.07567 13.6467 3.01212 14.2343 2.42953C14.5805 2.09056 14.9058 1.71983 14.9687 1.6139C15.0737 1.41264 15.0632 1.41264 14.5281 1.59272C13.6362 1.91049 13.5103 1.86812 13.951 1.39146C14.2762 1.0525 14.6645 0.438131 14.6645 0.258058C14.6645 0.22628 14.5071 0.279243 14.3287 0.374576C14.1398 0.480501 13.7202 0.639389 13.4054 0.734722L12.8388 0.914795L12.3247 0.565241C12.0414 0.374576 11.6427 0.162725 11.4329 0.0991699C10.8978 -0.0491255 10.0794 -0.0279404 9.59673 0.14154C8.2852 0.618204 7.45632 1.84694 7.55075 3.19219Z" />
            </svg>
          </div>
          <span className="font-semibold px-3 block text-blueGray-700">
            Share on Twitter
          </span>
        </div>
      </Menu.Item>
      <Menu.Item
        className="py-3 share_wrapper border-t"
        onClick={() => {
          window?.navigator?.clipboard?.writeText?.(nftUrl ? nftUrl : nftUrl);
          toast.success('Link copied!', {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            zIndex: 2147483641,
          });
        }}
      >
        <div className="flex items-center text-sm text-blueGray-700">
          <a className="share__link share__link--link">
            <svg
              width="18"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="M8,12a1,1,0,0,0,1,1h6a1,1,0,0,0,0-2H9A1,1,0,0,0,8,12Zm2,3H7A3,3,0,0,1,7,9h3a1,1,0,0,0,0-2H7A5,5,0,0,0,7,17h3a1,1,0,0,0,0-2Zm7-8H14a1,1,0,0,0,0,2h3a3,3,0,0,1,0,6H14a1,1,0,0,0,0,2h3A5,5,0,0,0,17,7Z" />
            </svg>
          </a>
          <span className="font-semibold px-3 block">Copy Link</span>
        </div>
      </Menu.Item>
      <Menu.Item
        className="py-3 share_wrapper border-t"
        onClick={() => {
          setEmbedAssetsDialogState(true);
        }}
      >
        <div className="flex items-center text-sm text-blueGray-700">
          <a
            // href={`https://twitter.com/share?url=${nftUrl}`}
            // target="_blank"
            className="share__link share__link--embed"
          >
            {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
              <g>
                <path
                  d="M42.4,24.3c-1-1.3-2.9-1.6-4.2-0.6l-32,23.8C5.4,48.1,5,49,5,50c0,0,0,0,0,0c0,0,0,0,0,0c0,0.9,0.4,1.9,1.2,2.5l32,23.8
              c0.5,0.4,1.2,0.6,1.8,0.6c0.9,0,1.8-0.4,2.4-1.2c1-1.3,0.7-3.2-0.6-4.2L12.9,50l28.9-21.5C43.1,27.5,43.4,25.7,42.4,24.3z"
                />
                <path
                  d="M95,50C95,50,95,50,95,50c0-1-0.4-1.9-1.2-2.5l-32-23.8c-1.3-1-3.2-0.7-4.2,0.6c-1,1.3-0.7,3.2,0.6,4.2L87.1,50L58.2,71.5
              c-1.3,1-1.6,2.9-0.6,4.2c0.6,0.8,1.5,1.2,2.4,1.2c0.6,0,1.2-0.2,1.8-0.6l32-23.8C94.6,51.9,95,51,95,50C95,50,95,50,95,50z"
                />
              </g>
            </svg> */}

            <i className="fa fa-code"></i>
          </a>
          <span className="font-semibold px-3 block">Embed Asset</span>
        </div>
      </Menu.Item>
    </Menu>
  );

  const getValidDate = () => {
    const today = new Date();
    return new Date(today.setHours(today.getHours() + 24));
  };

  const countDownrenderer = ({ completed, formatted }) => {
    if (completed) {
      // Render a completed state
      return <div />;
    } else {
      console.log('formatted', formatted);
      // Render a countdown
      return (
        <span>
          {Number(formatted.days) ? `${formatted.days}:` : ''}
          {Number(formatted.hours)
            ? `${formatted.hours}:`
            : Number(formatted.days)
            ? '00:'
            : ''}
          {Number(formatted.minutes) ? `${formatted.minutes}:` : '00:'}
          {Number(formatted.seconds) ? `${formatted.seconds}` : '00'}
        </span>
      );
    }
  };

  const onCompleteCounter = () => {
    setauctionTimerEnded(true);
  };

  if (showftNftDetails) {
    return (
      <>
        {/* //seo */}
        {props.data && props.musicData && props.bsvRate && (
          <>
            <NextSeo
              title={`${props.data.tokenName}${
                props.musicData.name ? ` - ` + props.musicData.name + ` - ` : ''
              }NFT - MusicArt`}
              description={
                props.data.tokenDescription
                  ? props.data.tokenDescription.replace(/"/g, '&quot;')
                  : '-'
              }
              openGraph={{
                type: 'website',
                title: `${props.data.tokenName}${
                  props.musicData.name
                    ? ` - ` + props.musicData.name + ` - `
                    : ''
                }NFT - MusicArt`,
                description: props.data.tokenDescription
                  ? props.data.tokenDescription.replace(/"/g, '&quot;')
                  : '-',
                images: [
                  {
                    url:
                      props.data &&
                      props.data.nftType === 'Audio' &&
                      props?.nftData?.audioCoverFile1500 &&
                      props.data.audioCoverFile1500[0]
                        ? props.data.audioCoverFile1500[0]
                        : props.data &&
                          props.data.stasTokenImgArr1500 &&
                          props.data.stasTokenImgArr1500[0]
                        ? props.data.stasTokenImgArr1500[0]
                        : 'https://i.imgur.com/Q0kiEsg.jpg',
                  },
                ],
                site_name: 'MusicArt',
              }}
              twitter={{
                cardType: 'summary_large_image',
              }}
            />
            <NftSchema
              nftData={props.data}
              musicData={props.musicData}
              offers={[
                {
                  price: Number(props.data.price).toFixed(2),
                  priceCurrency: 'USD',
                  priceValidUntil: getValidDate().toISOString(),
                  availability: 'InStock',
                  url: `https://musicart.io/nft/${nftId}${
                    multiNftId ? `/${multiNftId}` : ''
                  }`,
                  // seller: {
                  //   name: props.data.issuerName,
                  // },
                },
              ]}
            />
          </>
        )}

        <div>
          <div className="row row--grid">
            <div className="w-full">
              <ul className="breadcrumb">
                <li className="breadcrumb__item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb__item">
                  <a href="/discover">Discover</a>
                </li>
                <li className="breadcrumb__item breadcrumb__item--active">
                  {nftData && nftData.tokenName ? nftData.tokenName : '-'}
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div className="row pb-10">
              <div className="w-full xl:w-8/12 px-4">
                <div className="asset__item">
                  <div
                    className="asset__img"
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      maxWidth: 500,
                    }}
                  >
                    {(() => {
                      if (nftData && nftData.nftType === 'Audio') {
                        return (
                          showData &&
                          nftData &&
                          nftData.audioCoverFile1500 &&
                          nftData.audioCoverFile1500.length > 0 && (
                            <div
                              style={{
                                height: '100%',
                                width: '100%',
                                position: 'relative',
                              }}
                            >
                              <div
                                style={{
                                  zIndex: 9999,
                                }}
                              >
                                <Slider {...settings}>
                                  {nftData.audioCoverFile1500 &&
                                    nftData.audioCoverFile1500.map(
                                      (ele, index) => {
                                        return (
                                          <div
                                            key={ele + index + 'nft_details'}
                                          >
                                            <div
                                              style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                zIndex: 9999,
                                              }}
                                            >
                                              <LightgalleryItem
                                                src={
                                                  nftData?.audioCoverFile10000_full
                                                    ? nftData
                                                        ?.audioCoverFile10000_full?.[
                                                        index
                                                      ]
                                                    : nftData?.audioCoverFile1500_full
                                                    ? nftData
                                                        ?.audioCoverFile1500_full?.[
                                                        index
                                                      ]
                                                    : ele
                                                }
                                              >
                                                <Image
                                                  src={
                                                    ele
                                                      ? ele
                                                      : '/img/cover/cover_260x260.jpg'
                                                  }
                                                  className="object-cover"
                                                  alt="nft image"
                                                  style={{
                                                    display: 'block',
                                                  }}
                                                  width="500"
                                                  height="500"
                                                />
                                              </LightgalleryItem>
                                            </div>
                                          </div>
                                        );
                                      },
                                    )}
                                </Slider>
                              </div>
                              <div
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  height: '100%',
                                  width: '100%',
                                  pointerEvents: 'none',
                                }}
                              >
                                <div
                                  className="flex items-end absolute"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setaudioPlay(!audioPlay);
                                  }}
                                  style={{
                                    bottom: 0,
                                    right: 0,
                                  }}
                                >
                                  <div
                                    className="ml-auto w-full flex justify-center items-center blue_color btn_overwrite_background"
                                    style={{
                                      width: 100,
                                      height: 100,
                                      marginRight: 0,
                                      zIndex: 10,
                                    }}
                                  >
                                    <Fab
                                      color="secondary"
                                      style={{
                                        background: 'transparent',
                                        boxShadow: 'none',
                                        pointerEvents: 'auto',
                                      }}
                                      className="btn-color"
                                    >
                                      {!audioPlay ? (
                                        <PlayCircleIcon fontSize="large" />
                                      ) : (
                                        <PauseCircleIcon fontSize="large" />
                                      )}
                                    </Fab>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    height: '100%',
                                    pointerEvents: 'none',
                                  }}
                                >
                                  {audioPlay && (
                                    <Lottie
                                      options={{
                                        loop: true,
                                        autoplay: true,
                                        animationData: musicAnimation,
                                      }}
                                      speed={1}
                                      isClickToPauseDisabled={true}
                                      style={{
                                        margin: 'auto',
                                        width: '100%',
                                        position: 'absolute',
                                        zIndex: 101,
                                      }}
                                    />
                                  )}
                                  <ReactPlayer
                                    playsinline={true}
                                    width="500"
                                    height="500"
                                    url={nftData.sampleAudioFile}
                                    controls={false}
                                    playing={audioPlay}
                                    onEnded={() => {
                                      if (audioPlay) {
                                        setaudioPlay(false);
                                      }
                                    }}
                                    style={{
                                      position: 'absolute',
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          )
                        );
                      } else {
                        return (
                          showData &&
                          nftData &&
                          nftData.icons &&
                          nftData.icons.length > 0 && (
                            <Slider {...settings}>
                              {nftData.stasTokenImgArr1500 &&
                                nftData.stasTokenImgArr1500.map(
                                  (ele, index) => {
                                    return (
                                      <div key={ele + index + 'nft_details'}>
                                        <div
                                          style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                          }}
                                        >
                                          {ele.includes('_video') ? (
                                            <ReactPlayer
                                              playsinline={true}
                                              height="100%"
                                              width="100%"
                                              url={ele}
                                              controls={true}
                                              playing={true}
                                              loop={true}
                                            />
                                          ) : (
                                            <LightgalleryItem
                                              src={
                                                nftData?.stasTokenImgArr10000_full
                                                  ? nftData
                                                      ?.stasTokenImgArr10000_full?.[
                                                      index
                                                    ]
                                                  : nftData?.stasTokenImgArr3000_full
                                                  ? nftData
                                                      ?.stasTokenImgArr3000_full?.[
                                                      index
                                                    ]
                                                  : ele
                                              }
                                            >
                                              <Image
                                                src={
                                                  ele
                                                    ? ele
                                                    : '/img/cover/cover_260x260.jpg'
                                                }
                                                className="object-cover"
                                                alt="nft image"
                                                style={{
                                                  display: 'block',
                                                }}
                                                width="500"
                                                height="500"
                                              />
                                            </LightgalleryItem>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  },
                                )}
                            </Slider>
                          )
                        );
                      }
                    })()}
                  </div>

                  <Text strong>Click on image to view full size artwork</Text>
                  <div
                    className="actions"
                    style={{
                      left: 20,
                      justifyContent: 'flex-start',
                      fontSize: 16,
                      color: '#0f0f0f',
                    }}
                  >
                    {nftCount && (
                      <>{`${nftCount}/${parseInt(data.nftQuantity)}`}</>
                    )}
                  </div>
                  <div className="actions">
                    <div className="share share--asset">
                      <Dropdown
                        overlay={menuDropdown}
                        placement="bottomLeft"
                        className="sharebutton"
                      >
                        <button
                          className="accets_share px-4 ease-linear transition-all duration-150"
                          type="button"
                        >
                          <Tooltip
                            title="Share"
                            classes={classes}
                            arrow
                            placement="top"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                              width="20px"
                              height="18px"
                            >
                              <g>
                                <g>
                                  <path
                                    d="M406,332c-29.641,0-55.761,14.581-72.167,36.755L191.99,296.124c2.355-8.027,4.01-16.346,4.01-25.124
    c0-11.906-2.441-23.225-6.658-33.636l148.445-89.328C354.307,167.424,378.589,180,406,180c49.629,0,90-40.371,90-90
    c0-49.629-40.371-90-90-90c-49.629,0-90,40.371-90,90c0,11.437,2.355,22.286,6.262,32.358l-148.887,89.59
    C156.869,193.136,132.937,181,106,181c-49.629,0-90,40.371-90,90c0,49.629,40.371,90,90,90c30.13,0,56.691-15.009,73.035-37.806
    l141.376,72.395C317.807,403.995,316,412.75,316,422c0,49.629,40.371,90,90,90c49.629,0,90-40.371,90-90
    C496,372.371,455.629,332,406,332z"
                                  />
                                </g>
                              </g>
                            </svg>
                          </Tooltip>
                        </button>
                      </Dropdown>

                      {(artistDetails?.spotify || nftData?.spotify) && (
                        <div
                          className="asset_spotify flex items-center text-sm text-blueGray-700"
                          //  onClick={() => {
                          //    setSpotifyDialogState(true);
                          //  }}
                        >
                          <Tooltip
                            title="Spotify"
                            classes={classes}
                            arrow
                            placement="top"
                          >
                            <a
                              className="flex justify-around px-4"
                              href={
                                nftData?.spotify
                                  ? nftData.spotify
                                  : artistDetails.spotify
                              }
                              rel="noreferrer"
                              target="_blank"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 186.845 186.845"
                                width="20px"
                                height="18px"
                              >
                                <g>
                                  <path
                                    d="M128.875,120.962c-31.094-14.37-74.616-8.014-76.453-7.737c-4.096,0.619-6.915,4.44-6.296,8.536
 c0.619,4.096,4.443,6.912,8.536,6.296c0.406-0.062,40.867-5.982,67.92,6.521c1.018,0.471,2.089,0.694,3.142,0.694
 c2.834-0.001,5.546-1.614,6.813-4.355C134.274,127.157,132.635,122.7,128.875,120.962z"
                                  />
                                  <path
                                    d="M137.614,93.953c-35.313-16.319-84.833-9.087-86.924-8.772c-4.094,0.619-6.911,4.438-6.294,8.532
 c0.616,4.095,4.438,6.916,8.531,6.301c0.468-0.071,47.206-6.857,78.394,7.556c1.02,0.471,2.089,0.694,3.142,0.694
 c2.834-0.001,5.546-1.614,6.814-4.356C143.014,100.148,141.374,95.691,137.614,93.953z"
                                  />
                                  <path
                                    d="M143.49,65.736c-39.006-18.027-93.79-10.028-96.103-9.679c-4.094,0.619-6.911,4.438-6.294,8.532s4.44,6.919,8.531,6.3
 c0.523-0.079,52.691-7.657,87.573,8.463c1.018,0.471,2.089,0.694,3.142,0.694c2.834,0,5.546-1.614,6.813-4.355
 C148.89,71.93,147.25,67.474,143.49,65.736z"
                                  />
                                  <path
                                    d="M93.423,0.001C41.909,0.001,0,41.909,0,93.42c0,51.514,41.909,93.424,93.423,93.424c51.513,0,93.422-41.91,93.422-93.424
 C186.845,41.909,144.936,0.001,93.423,0.001z M93.423,171.844C50.18,171.844,15,136.664,15,93.42
 c0-43.241,35.18-78.42,78.423-78.42c43.242,0,78.422,35.179,78.422,78.42C171.845,136.664,136.665,171.844,93.423,171.844z"
                                  />
                                </g>
                              </svg>
                            </a>
                          </Tooltip>
                          {/* <span className="font-normal px-3 block">Spotify</span> */}
                        </div>
                      )}
                      {(nftData?.apple || artistDetails?.apple) && (
                        <div
                          className="asset_apple flex items-center text-sm text-blueGray-700"
                          // onClick={() => {
                          //   setAppleDialogState(true);
                          // }}
                        >
                          <Tooltip
                            title="Apple"
                            classes={classes}
                            arrow
                            placement="top"
                          >
                            <a
                              className="flex justify-around px-4 py-2"
                              href={
                                nftData?.apple
                                  ? nftData.apple
                                  : artistDetails.apple
                              }
                              rel="noreferrer"
                              target="_blank"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 291.538 291.538"
                                width="20px"
                                height="18px"
                              >
                                <g>
                                  <path
                                    d="M188.373,44.308c10.97-11.744,18.39-28.049,16.359-44.308c-15.804,0.564-34.958,9.277-46.302,21.02
      c-10.169,10.396-19.072,27.011-16.696,42.951C159.369,65.164,177.385,56.033,188.373,44.308z M222.03,156.593
      c-0.337-36.451,28.859-53.958,30.152-54.804c-16.414-24.753-41.977-28.14-51.081-28.522c-21.767-2.285-42.442,13.182-53.493,13.182
      c-11.006,0-28.03-12.882-46.083-12.536c-23.733,0.391-45.601,14.211-57.79,36.114C19.081,154.09,37.416,219.363,61.44,255.104
      c11.744,17.497,25.727,37.125,44.089,36.415c17.725-0.71,24.407-11.789,45.792-11.789c21.394,0,27.384,11.789,46.101,11.434
      c19.045-0.355,31.098-17.834,42.742-35.386c13.473-20.292,19.027-39.938,19.345-40.93
      C259.1,214.611,222.421,200.182,222.03,156.593z"
                                  />
                                </g>
                              </svg>
                            </a>
                          </Tooltip>
                          {/* <span className="font-normal px-3 block">Apple</span> */}
                        </div>
                      )}
                    </div>

                    <button
                      className="card__likes asset__likes px-2"
                      type="button"
                      disabled={!showData}
                      onClick={async () => {
                        if (!userDataRedux) {
                          router.push(
                            `/auth/login?page=nft/${nftData.tokenId}`,
                          );
                        } else {
                          let modifiedObj = { ...nftData };
                          let inc = true;
                          if (!liked === false) {
                            inc = false;
                          }
                          let likeAPI = httpsCallable(
                            firebaseFunctions,
                            'musicartLikeNFT',
                          );
                          musicartLikeNFT(
                            inc,
                            nftId,
                            false,
                            null,
                            userDataRedux && userDataRedux.uid
                              ? userDataRedux.uid
                              : '',
                          );
                          // setlikedNfts(modifiedArr);
                          // props.setnftDataArr(modifiedArr2);
                          // if (props.reloadlikednfts) {
                          //   props.reloadlikednfts(props.ele.tokenId);
                          // }

                          await likeAPI({
                            like: inc,
                            tokenId: nftId,
                            nftId: null,
                            isMultiple: false,
                          }).then((data) => {
                            modifiedObj.likes = !liked
                              ? modifiedObj.likes + 1
                              : modifiedObj.likes - 1;
                            setliked(!liked);
                            if (modifiedObj.likes >= 0) {
                              setnftData(modifiedObj);
                            }
                          });

                          //update firestore
                          // musicartLikeNFT(
                          //   inc,
                          //   nftId,
                          //   props.isMultiple,
                          //   multiNftId,
                          //   userDataRedux && userDataRedux.uid
                          //     ? userDataRedux.uid
                          //     : '',
                          // )
                          // .then((res) => {
                          //   modifiedObj.likes = !liked
                          //     ? modifiedObj.likes + 1
                          //     : modifiedObj.likes - 1
                          //   setliked(!liked)
                          //   if (modifiedObj.likes >= 0) {
                          //     setnftData(modifiedObj)
                          //   }
                          // })
                          // .catch((err) => {
                          //   toast.error('Something went wrong', {
                          //     position: 'bottom-left',
                          //     autoClose: 10000,
                          //     hideProgressBar: false,
                          //     closeOnClick: true,
                          //     pauseOnHover: true,
                          //     draggable: true,
                          //   })
                          // })
                        }
                      }}
                    >
                      <span>
                        {liked ? (
                          <i className="fas fa-heart" />
                        ) : (
                          <i className="far  fa-heart" />
                        )}
                      </span>
                      <span>
                        {nftData && nftData.likes ? nftData.likes : 0}
                      </span>
                    </button>
                  </div>
                </div>
              </div>

              <div className="w-full xl:w-4/12 px-4">
                <div className="asset__info">
                  <div className="asset__desc row">
                    <div className="w-6/12">
                      <h2>Title</h2>
                      <h1
                        className="main_inner_heading"
                        style={{ fontSize: '16px' }}
                      >
                        {nftData && nftData.tokenName ? nftData.tokenName : '-'}
                      </h1>
                    </div>
                    <div className="w-6/12">
                      <h2>Collection</h2>
                      <p>
                        <Link
                          href={`/discover/?collection=${
                            nftData && nftData.collection
                              ? encodeURIComponent(
                                  nftData.collection,
                                ).toLowerCase()
                              : ''
                          }`}
                        >
                          <a className="link" target={'_parent'}>
                            {nftData && nftData.collection && nftData.collection
                              ? nftData.collection
                              : '-'}
                          </a>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <div className="asset__authors row">
                    <div className="w-6/12">
                      <span>MusicArtist</span>
                      <div
                        className={'asset__author '}
                        style={{
                          height: 55,
                        }}
                      >
                        <img
                          src={
                            artistDetails && artistDetails.photoUrl
                              ? artistDetails.photoUrl + '_250x250?alt=media'
                              : '/img/avatars/avatar.jpg'
                          }
                          alt=""
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '/img/avatars/avatar.jpg';
                          }}
                        />
                        {artistDetails?.name ? (
                          <Link
                            href={`/artist/${
                              artistDetails ? artistDetails.artistId : ''
                            }`}
                          >
                            <a>
                              {/* {
                         artistDetails ? artistDetails.name : ""
                      } */}
                              {artistDetails.name}
                            </a>
                          </Link>
                        ) : (
                          '--'
                        )}
                      </div>
                    </div>
                    {/* <div className="w-6/12">
                <span>Minter</span>
                <div className="asset__author asset__author--verified">
                  <img
                    src={
                      nftData.issuerImage
                        ? nftData.issuerImage
                        : "/img/avatars/avatar.jpg"
                    }
                    alt=""
                  />
                  <Link href={"/collector/" + nftData.userId}>
                    <a>@{nftData.issuerName}</a>
                  </Link>
                </div>
              </div> */}
                  </div>
                  <TabsComponent
                    nftData={nftData}
                    setnftData={setnftData}
                    isMultiple={props.isMultiple}
                    setcheckoutUserName={setcheckoutUserName}
                    checkoutUserName={checkoutUserName}
                    multiNftId={multiNftId}
                    artistDetails={artistDetails}
                    userDataRedux={userDataRedux}
                    isAdmin={props.isAdmin}
                  />
                  {nftData && nftData.multiView ? (
                    <>
                      <div className="asset__wrap">
                        <div className="asset__price">
                          <span>Price starting from</span>

                          <div
                            className="bsv_size_size"
                            style={{ display: 'flex' }}
                          >
                            {/* //dollar */}
                            <div className="font-bold">
                              $
                              {nftData && nftData.startingPrice
                                ? Number(nftData.startingPrice).toFixed(2)
                                : ''}{' '}
                            </div>
                            &nbsp;&nbsp;
                            {/* //BSV */}
                            <span className="flex">
                              {bsvRate && (
                                <Tooltip title="BSV" classes={classes}>
                                  <div className="relative cursor-pointer">
                                    <img
                                      className="mr-0-5 ml-1"
                                      style={{
                                        width: '14px',
                                        display: 'unset',
                                        position: 'relative',
                                        bottom: 1,
                                      }}
                                      src={'/img/bsvlogo.svg'}
                                    />
                                  </div>
                                </Tooltip>
                              )}
                              &nbsp;
                              <span>
                                {nftData &&
                                bsvRate &&
                                nftData.startingPrice &&
                                Number(nftData.startingPrice / bsvRate) &&
                                countDecimals(
                                  Number(nftData.startingPrice / bsvRate),
                                ) &&
                                countDecimals(
                                  Number(nftData.startingPrice / bsvRate),
                                ) > 4
                                  ? Number(
                                      nftData.startingPrice / bsvRate,
                                    ).toFixed(4)
                                  : nftData && nftData.startingPrice / bsvRate
                                  ? nftData.startingPrice / bsvRate
                                  : ''}
                              </span>
                            </span>
                            &nbsp;&nbsp;
                            {/* //ETH */}
                            <span className="flex ">
                              {ethRate && (
                                <Tooltip title="ETH" classes={classes}>
                                  <div className="relative cursor-pointer">
                                    <img
                                      className="mr-0-5 ml-1"
                                      style={{
                                        width: '10px',
                                        display: 'unset',
                                        position: 'relative',
                                        bottom: 1,
                                      }}
                                      src={'/img/ethlogo.svg'}
                                    />
                                  </div>
                                </Tooltip>
                              )}
                              &nbsp;
                              <span>
                                {ethRate &&
                                nftData &&
                                nftData.startingPrice &&
                                Number(nftData.startingPrice)
                                  ? (
                                      Number(nftData.startingPrice) / ethRate
                                    ).toFixed(4)
                                  : ''}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="asset__btns"></div>
                    </>
                  ) : (
                    <>
                      {nftData && nftData.nftSaleType === 'Auctioning' ? (
                        <div className="asset__wrap">
                          <div className="asset__timer">
                            <span style={{ height: 35 }}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                              >
                                <path d="M18.3,8.59l.91-.9a1,1,0,0,0-1.42-1.42l-.9.91a8,8,0,0,0-9.79,0l-.91-.92A1,1,0,0,0,4.77,7.69l.92.91A7.92,7.92,0,0,0,4,13.5,8,8,0,1,0,18.3,8.59ZM12,19.5a6,6,0,1,1,6-6A6,6,0,0,1,12,19.5Zm-2-15h4a1,1,0,0,0,0-2H10a1,1,0,0,0,0,2Zm3,6a1,1,0,0,0-2,0v1.89a1.5,1.5,0,1,0,2,0Z" />
                              </svg>{' '}
                              {Number(moment().format('x')) >=
                                Number(nftData.auctionEndTime) ||
                              auctionTimerEnded ? (
                                'Auction has been ended'
                              ) : (
                                <>
                                  Auction ends in{' '}
                                  {Number(nftData.auctionEndTime)
                                    ? moment(
                                        Number(nftData.auctionEndTime),
                                      ).fromNow(true)
                                    : ''}
                                </>
                              )}
                            </span>
                            {Number(nftData.auctionStartTime) ? (
                              <span
                                style={{
                                  marginTop: 4,
                                }}
                                className="flex flex-wrap"
                              >
                                <span className="text_in_one_line mr-1">
                                  Start:
                                </span>
                                <span className="text_in_one_line">
                                  {moment(
                                    Number(nftData.auctionStartTime),
                                  ).format('DD MMM YYYY, HH:mm')}
                                </span>
                              </span>
                            ) : (
                              ''
                            )}
                            {Number(moment().format('x')) <
                              Number(nftData.auctionEndTime) &&
                            !auctionTimerEnded ? (
                              <span
                                style={{
                                  marginTop: 4,
                                }}
                                className="flex flex-wrap font-semibold"
                              >
                                <span className="text_in_one_line mr-1">
                                  Time left:
                                </span>
                                <span className="text_in_one_line">
                                  <Countdown
                                    date={Number(nftData.auctionEndTime)}
                                    renderer={countDownrenderer}
                                    onComplete={onCompleteCounter}
                                  />
                                </span>
                              </span>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div className="asset__price">
                            <span>Minimum bid</span>
                            {/* Minimum bid */}

                            <div
                              className="bsv_size_size"
                              style={{ display: 'flex' }}
                            >
                              {/* //dollar */}
                              <div className="font-bold">
                                $
                                {nftData && nftData.minBiddingPrice
                                  ? Number(nftData.minBiddingPrice).toFixed(2)
                                  : ''}{' '}
                              </div>
                              &nbsp;&nbsp;
                              {/* //BSV */}
                              <span className="flex">
                                {bsvRate && (
                                  <Tooltip title="BSV" classes={classes}>
                                    <div className="relative cursor-pointer">
                                      <img
                                        className="mr-0-5 ml-1"
                                        style={{
                                          width: '14px',
                                          display: 'unset',
                                          position: 'relative',
                                          bottom: 1,
                                        }}
                                        src={'/img/bsvlogo.svg'}
                                      />
                                    </div>
                                  </Tooltip>
                                )}
                                &nbsp;
                                <span>
                                  {nftData &&
                                  bsvRate &&
                                  nftData.minBiddingPrice &&
                                  Number(nftData.minBiddingPrice / bsvRate) &&
                                  countDecimals(
                                    Number(nftData.minBiddingPrice / bsvRate),
                                  ) &&
                                  countDecimals(
                                    Number(nftData.minBiddingPrice / bsvRate),
                                  ) > 4
                                    ? Number(
                                        nftData.minBiddingPrice / bsvRate,
                                      ).toFixed(4)
                                    : nftData &&
                                      nftData.minBiddingPrice / bsvRate
                                    ? nftData.startingPrice / bsvRate
                                    : ''}
                                </span>
                              </span>
                              &nbsp;&nbsp;
                              {/* //ETH */}
                              <span className="flex ">
                                {ethRate && (
                                  <Tooltip title="ETH" classes={classes}>
                                    <div className="relative cursor-pointer">
                                      <img
                                        className="mr-0-5 ml-1"
                                        style={{
                                          width: '10px',
                                          display: 'unset',
                                          position: 'relative',
                                          bottom: 1,
                                        }}
                                        src={'/img/ethlogo.svg'}
                                      />
                                    </div>
                                  </Tooltip>
                                )}
                                &nbsp;
                                <span>
                                  {ethRate &&
                                  nftData.minBiddingPrice &&
                                  Number(nftData.minBiddingPrice)
                                    ? (
                                        Number(nftData.minBiddingPrice) /
                                        ethRate
                                      ).toFixed(4)
                                    : ''}
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="asset__wrap">
                          <div className="asset__price">
                            <span>Price</span>

                            <div
                              className="bsv_size_size"
                              style={{ display: 'flex' }}
                            >
                              {/* //dollar */}
                              <div className="font-bold">
                                $
                                {nftData && nftData.price
                                  ? Number(nftData.price).toFixed(2)
                                  : ''}{' '}
                              </div>
                              &nbsp;&nbsp;
                              {/* //BSV */}
                              <span className="flex">
                                {bsvRate && (
                                  <Tooltip title="BSV" classes={classes}>
                                    <div className="relative cursor-pointer">
                                      <img
                                        className="mr-0-5 ml-1"
                                        style={{
                                          width: '14px',
                                          display: 'unset',
                                          position: 'relative',
                                          bottom: 1,
                                        }}
                                        src={'/img/bsvlogo.svg'}
                                      />
                                    </div>
                                  </Tooltip>
                                )}
                                &nbsp;
                                <span>
                                  {nftData &&
                                  nftData.price &&
                                  bsvRate &&
                                  Number(nftData.price / bsvRate) &&
                                  countDecimals(
                                    Number(nftData.price / bsvRate),
                                  ) &&
                                  countDecimals(
                                    Number(nftData.price / bsvRate),
                                  ) > 4
                                    ? Number(nftData.price / bsvRate).toFixed(4)
                                    : nftData && nftData.price / bsvRate
                                    ? nftData.price / bsvRate
                                    : ''}
                                </span>
                              </span>
                              &nbsp;&nbsp;
                              {/* //ETH */}
                              <span className="flex ">
                                {ethRate && (
                                  <Tooltip title="ETH" classes={classes}>
                                    <div className="relative cursor-pointer">
                                      <img
                                        className="mr-0-5 ml-1"
                                        style={{
                                          width: '10px',
                                          display: 'unset',
                                          position: 'relative',
                                          bottom: 1,
                                        }}
                                        src={'/img/ethlogo.svg'}
                                      />
                                    </div>
                                  </Tooltip>
                                )}
                                &nbsp;
                                <span>
                                  {ethRate &&
                                  nftData &&
                                  nftData.price &&
                                  Number(nftData.price)
                                    ? (Number(nftData.price) / ethRate).toFixed(
                                        4,
                                      )
                                    : ''}
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* Buy/Bid buttons hidden - Relysia discontinued */}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          <CheckoutDialog
            dialogState={confirmationCheckoutDialogState}
            setdialogState={setconfirmationCheckoutDialogState}
            nftData={nftData}
            ownerName={checkoutUserName}
            nftUrl={nftUrl}
          />
          <PlacebidDialog
            open={confirmationPlacebidDialogState}
            setdialogState={setconfirmationPlacebidDialogState}
            nftData={nftData}
            userDataRedux={userDataRedux}
            setnftData={setnftData}
          />

          <NftDetailsEmbadedAssetsDialog
            nftId={nftId}
            nftUrl={nftUrl}
            nftCode={NFT_Code && NFT_Code}
            dialogState={embedAssetsDialogState}
            setdialogState={setEmbedAssetsDialogState}
          />
        </div>
        <OtherNftsContainer data={props.data} />
      </>
    );
  } else {
    return <></>;
  }
}
